<!-- 设添加黑名单接口内容 -->
<template>
  <div class>
    <right-structure :Pdatas="infoData">
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
import structure from "@/components/commonStructure";

export default {
  name: "",
  components: {
    "right-structure": structure
  },
  props: ["commonUrls"],
  data() {
    return {
      requestBody: {
        "parkCodeList": [
          "2KNTYVWC",
          "2KNTYVCC"
        ],
        "redlistParam": "粤YKK123"
      },
      responseCode: {
        data: {
          ruleId: 1
        },
        message: "业务成功",
        resultCode: 0,
        status: 1
      },
      infoData: {
        explain: "第三方接入系统请求智慧停车开放平台添新增白名单规则",
        t_url: this.commonUrls.test + "redListAdd",
        p_url: this.commonUrls.prod + "redListAdd",
        pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
        Q_params: [
          {
            titleName: null,
            tabledata: [
              { tableHead: "参数名", tdName: "info1" },
              { tableHead: "是否必填", tdName: "info2" },
              { tableHead: "类型", tdName: "info3" },
              { tableHead: "说明", tdName: "info4" }
            ],
            td: [
              {
                info1: "redlistParam",
                info2: "是",
                info3: "String",
                info4:
                  "车牌号码或规则 如：指定某辆车 粤EJW123,如 *警，表示所有以 “警” 字结尾车辆都是白名单车辆"
              },
              // { info1: 'vipTypeCode', info2: '否', info3: 'String', info4: 'VIP类型唯一编号，黑名单沿用VIP类型的模型，添加黑名单需指定“VIP类型编号”或“VIP类型名称”' },
              // { info1: 'vipTypeName', info2: '否', info3: 'String', info4: 'VIP类型名称，如果没有对接“新增月卡类型”接口，可以在停车场管理系统预先建好黑名单的VIP类型，然后按“VIP类型名称”添加黑名单' },
              {
                info1: "parkCodeList",
                info2: "是",
                info3: "String",
                info4:
                  "停车场parkCode列表"
              },
              {
                info1: "plateColor",
                info2: "否",
                info3: "int",
                info4:
                  "车牌颜色：0其他，1蓝色，2黄色，3白色，4黑色，5绿色"
              },
              {
                info1: "operator",
                info2: "否",
                info3: "String",
                info4:
                  "操作人"
              },
              {
                info1: "remark",
                info2: "否",
                info3: "String",
                info4:
                  "备注"
              }
            ]
          }
        ],
        R_params: [
          {
            titleName: null,
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [
              {info1: 'ruleId', info2: '是', info3: 'Long', info4: '规则Id'}
            ]
          }
        ],
        codeStatus: [
          {
            titleName: null,
            tabledata: [
              { tableHead: "状态码", tdName: "info1" },
              { tableHead: "说明", tdName: "info2" }
            ],
            td: [
              { info1: "000110", info2: "失败" },
              { info1: "00110000", info2: "失败" },
              { info1: "110000", info2: "失败" }
            ]
          }
        ]
      }
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
 /* @import "../../assets/less/conmon.less"; */
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/redlist/redListAdd.vue